import React from 'react';
import { Tracker } from '@jbhi-fi/components/src/Tracking';
import IEWarning from '../components/common/ie-warning.component';
import { getCustomerTrackingData } from '../../../../utils/event-tracking/event-data';
import { getMultiTenancyHeaders } from '../../../../utils/multiTenancyHeaders';

type RequestInit = Required<Parameters<typeof fetch>[1]>;

export const getBrowserWarning = (): JSX.Element => (window?.document?.documentMode ? <IEWarning /> : <></>);

export const decodeHtml = (input: string) =>
  new DOMParser().parseFromString(input, 'text/html').documentElement.textContent;

type appendReturnUrlProps = {
  baseUrl: string;
  baseParams?: {
    [param: string]: string;
  };
  returnUrl: string;
  returnParams?: {
    [param: string]: string;
  };
};

export const appendReturnUrl = ({
  baseUrl,
  baseParams = {},
  returnUrl = '/account#/manage-account',
  returnParams = {},
}: appendReturnUrlProps): string => {
  return `${baseUrl}?${new URLSearchParams({
    ...baseParams,
    referrer: window.location.href,
    returnUrl: `${returnUrl}${Object.keys(returnParams).length !== 0 ? `?${new URLSearchParams(returnParams)}` : ''}`,
  })}`;
};

export const expandProvince = (province: string): string => {
  let state = province;

  switch (province) {
    case 'NT':
      state = 'Northern Territory';
      break;
    case 'QLD':
      state = 'Queensland';
      break;
    case 'SA':
      state = 'South Australia';
      break;
    case 'TAS':
      state = 'Tasmania';
      break;
    case 'VIC':
      state = 'Victoria';
      break;
    case 'WA':
      state = 'Western Australia';
      break;
    case 'NSW':
      state = 'New South Wales';
  }

  return state;
};

export const fetchJson = async (
  url: string,
  request: RequestInit,
  validateStatus?: (status: number) => boolean,
  responseType?: 'text',
  signal?: AbortSignal
): Promise<any> => {
  try {
    const fetchResponse = await fetch(url, {
      ...request,
      headers: {
        ...request?.headers,
        ...getMultiTenancyHeaders(),
      },
      signal: signal,
    });
    if (!fetchResponse.ok && (!validateStatus || !validateStatus(fetchResponse.status))) {
      throw `Error fetching json response from ${url}`;
    }

    if (responseType === 'text') {
      return await fetchResponse.text();
    }
    return await fetchResponse.json();
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const trackFirstView = ({
  reactHistory,
  reactLocation,
  baseTracker,
}: {
  reactHistory: any;
  reactLocation: any;
  baseTracker: Tracker;
}) => {
  const searchParams = new URLSearchParams(reactLocation.search);
  const gtmContext = searchParams.get('gtmContext') ?? baseTracker.context;
  const gtmCategory = searchParams.get('gtmCategory') ?? baseTracker.category;
  const firstViewTracker = new Tracker({
    context: gtmContext,
    category: gtmCategory,
    group: baseTracker.group,
    extraData: baseTracker.extraData,
    getCustomerTrackingData: getCustomerTrackingData,
  });

  firstViewTracker.trackView();

  searchParams.delete('gtmContext');
  searchParams.delete('gtmCategory');
  reactHistory.replace({ search: searchParams ? `?${searchParams}` : '' });
};
